export const state = {
    isMobile: false,
};

export const getters = {
    isMobile: state => state.isMobile,
};

export const mutations = {
    setIsMobile(state, newValue) {
        state.isMobile = newValue
    },
};

export const actions = {
    changeIsMobile({commit}) {
        commit('setIsMobile', window.innerWidth < 920)
    },
};
